import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import DebtSelector from "@main/debts/components/DebtSelector";
import UserSelector from "@beeldit/user-and-access/users/components/UserSelector";
import ConceptSelector from "@main/charges/components/ConceptSelector";
import PaymentMethodSelector from "@main/charges/components/PaymentMethodSelector";
import { Pencil, Plus, Trash } from "@phosphor-icons/react";
import { t } from "i18next";
import { title } from "process";

const config = {
  modelName: "charge",
  modelPluralName: "charges",
  endpoint: "charges",
  indexQueryParams: {
    relations: ["debt"],
  },
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "concept",
        label: "concept",
        key: "concept",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "date",
        label: "date",
        key: "date",
        type: "date",
        show: true,
        allowOrder: true,
      },
      {
        name: "amount",
        label: "amount",
        key: "amount",
        type: "currency",
        currency: "EUR",
        show: true,
        allowOrder: true,
      },
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      concept: {
        type: "string",
        title: "Operación",
      },
      payment_method: {
        type: "number",
        title: "Forma de cobro",
      },
      date_from: {
        type: "string",
        title: "Fecha de inicio",
        format: "date",
      },
      date_to: {
        type: "string",
        title: "Fecha final",
        format: "date",
      },
      search: {
        type: "string",
        title: "Búsqueda",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      concept: {
        "ui:widget": "concept-selector",
        "ui:options": {
          label: "Operación",
        },
      },
      payment_method: {
        "ui:widget": "payment-method-selector",
        "ui:options": {
          label: "Forma de cobro",
        },
      },
      date_from: {
        "ui:options": {
          label: "Fecha de inicio",
          placeholder: "Fecha desde",
        },
      },
      date_to: {
        "ui:options": {
          label: "Fecha final",
          placeholder: "Fecha hasta",
        },
      },
      search: {
        "ui:options": {
          label: "Búsqueda",
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {
      "concept-selector": ConceptSelector,
      "payment-method-selector": PaymentMethodSelector,
    },
  },
  formSchema: {
    type: "object",
    properties: {
      concept: {
        type: "string",
        title: t("concept"),
      },
      debt_id: {
        type: ["number", "null"],
        title: t("debt_id"),
      },
      user_id: {
        type: ["number", "null"],
        title: t("attended_by"),
      },
      amount: {
        type: "number",
        title: t("amount"),
        minimum: 0,
        default: 0,
      },
      date: {
        type: "string",
        title: t("date"),
        format: "date",
      },
      comments: {
        type: ["string", "null"],
        title: t("comments"),
        format: "textarea",
      },
      payment_method: {
        type: ["number", "null"],
        title: t("payment_method"),
        default: -1,
        oneOf: [
          {
            const: -1,
            title: "Seleccione una opción",
          },
          {
            const: 1,
            title: "Beca",
          },
          {
            const: 2,
            title: "Domiciliación bancaria",
          },
          {
            const: 3,
            title: "Efectivo",
          },
          {
            const: 4,
            title: "Financiación",
          },
          {
            const: 5,
            title: "Transferencia",
          },
        ],
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    user_id: {
      "ui:widget": UserSelector,
      "ui:options": {
        filters: { role: "admin,worker" },
      },
    },
    concept: {
      "ui:widget": ConceptSelector,
    },
    debt_id: {
      "ui:widget": DebtSelector,
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            {
              name: "debt_id",
              cols: "col-12",
            },
            {
              name: "user_id",
              cols: "col-6",
            },
            {
              name: "concept",
              cols: "col-6",
            },
            {
              name: "date",
              cols: "col-6",
            },
            {
              name: "payment_method",
              cols: "col-6",
            },
            {
              name: "amount",
              cols: "col-6",
            },
            {
              name: "comments",
              cols: "col-12",
              "ui:widget": "textarea",
            },
          ],
        ],
      },
    ],
  },
};
export default config;
